<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img src="../assets/white.png">
    </CHeaderBrand>
  </CHeader>
</template>

<script>
export default {
  name: 'TheHeader'
}
</script>

<style scoped>
body > div > div.c-wrapper > header > a > img
{
  height: 48px;
  width: auto;
}
</style>